import { Modal } from "antd";
import React, { useState } from "react";
import { valoresDefaultRequest } from "../../valoresDefaultRequest";
import { ModalStatusDelete } from "../../../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deletarVd = async () => {
    setLoading(true);
    try {
      const response = await valoresDefaultRequest.deleteValoresDefault(id);
      if (response.status === 204) {
        onCancel();
        onDelete((prevState) => {
          return prevState.filter((defaultValue) => {
            return defaultValue.id !== id;
          });
        });
        setLoading(false);
        setOpenModalStatus(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deletarVd}
        confirmLoading={loading}
      >
        <text style={{ fontWeight: "500", fontSize: 16 }}>
          Deseja deletar este Valor Default?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
